import dayjs from 'dayjs';
import { StyledReleaseDate } from '../styled';

interface ReleaseDateProps {
  date: string | Date;
  subtitle?: string;
}

export const ReleaseDate = ({ date, subtitle }: ReleaseDateProps) => {
  return (
    <StyledReleaseDate>
      {dayjs(date).format('MMM D, YYYY')}
      {subtitle ? ` - ${subtitle}` : ''}
    </StyledReleaseDate>
  );
};
